import { ExtensionContext } from "extensions"
import React from "react"

export default () => React.useContext(ExtensionContext)
